export default __webpack_public_path__ + "img/hamburger-menu.e7d2101aa4b0dd652875c288e4a5df65.svg";